module.exports = __webpack_public_path__ + "static/media/axiomlearning.4ef0ac1e.jpg";